// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Categories-allCategoryHeading-kpnLN {
  position: relative;
  font-size: 40px;
  font-weight: 700;
  line-height: 50px;
  color: var(--primary-foreground);
  word-break: break-word;
  margin-bottom: 48px;
  margin-top: 0;
  text-align: center;
}

.Categories-allCategoriesSearchInputContainer-oWTMf {
  max-width: 546px;
  margin: 0 auto 48px;
}

.Categories-allCategoriesSearchInputContainer-oWTMf>form {
  -webkit-box-shadow: 0px 4px 14px 0px var(--shadow-1);
          box-shadow: 0px 4px 14px 0px var(--shadow-1);
}

@media (max-width: 991px) and (min-width: 768px) {
  .Categories-allCategoryHeading-kpnLN {
    font-size: 30px;
    line-height: 44px;
    margin-bottom: 36px;
  }
}

@media (max-width: 767px) {
  .Categories-allCategoryHeading-kpnLN {
    font-size: 28px;
    line-height: 38px;
    margin-bottom: 24px;
  }

  .Categories-allCategoriesSearchInputContainer-oWTMf {
    margin: 0 auto 30px;
  }
}`, "",{"version":3,"sources":["webpack://./src/routes/category/Categories.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gCAAgC;EAChC,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,oDAA4C;UAA5C,4CAA4C;AAC9C;;AAEA;EACE;IACE,eAAe;IACf,iBAAiB;IACjB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,eAAe;IACf,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;AACF","sourcesContent":[".allCategoryHeading {\n  position: relative;\n  font-size: 40px;\n  font-weight: 700;\n  line-height: 50px;\n  color: var(--primary-foreground);\n  word-break: break-word;\n  margin-bottom: 48px;\n  margin-top: 0;\n  text-align: center;\n}\n\n.allCategoriesSearchInputContainer {\n  max-width: 546px;\n  margin: 0 auto 48px;\n}\n\n.allCategoriesSearchInputContainer>form {\n  box-shadow: 0px 4px 14px 0px var(--shadow-1);\n}\n\n@media (max-width: 991px) and (min-width: 768px) {\n  .allCategoryHeading {\n    font-size: 30px;\n    line-height: 44px;\n    margin-bottom: 36px;\n  }\n}\n\n@media (max-width: 767px) {\n  .allCategoryHeading {\n    font-size: 28px;\n    line-height: 38px;\n    margin-bottom: 24px;\n  }\n\n  .allCategoriesSearchInputContainer {\n    margin: 0 auto 30px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"allCategoryHeading": `Categories-allCategoryHeading-kpnLN`,
	"allCategoriesSearchInputContainer": `Categories-allCategoriesSearchInputContainer-oWTMf`
};
module.exports = ___CSS_LOADER_EXPORT___;
